import { Component, Input } from '@angular/core';
import { AppConfigService } from '@core/appconfig.service';
import { IProductLine } from '@models/product-line';
import { zbpIconNames } from '@shared/zbp-icon/zbp-icon-names';

@Component({
  selector: 'zbp-overview-my-products',
  templateUrl: './overview-my-products.component.html',
  styleUrls: ['./overview-my-products.component.scss'],
  standalone: false
})
export class OverviewMyProductsComponent {

  productLogos: Array<{ name: string, logoPath: string }> = [];

  @Input() set productLines(productLines: Array<IProductLine>) {
    // A product line's own logoPath is shared by all of its variants, so prefer the licensed variant logos.
    this.productLogos = (productLines ?? []).flatMap(productLine => (
      productLine.variantLogoPaths?.length
        ? productLine.variantLogoPaths
        : [productLine.logoPath]
    ).filter((logoPath): logoPath is string => !!logoPath)
      .map(logoPath => ({ name: productLine.name, logoPath })));
  }

  constructor(private appConfigService: AppConfigService) {
  }

  getProductLogoPath(product: { logoPath?: string }): string {
    if (product.logoPath) {
      return `${this.appConfigService.assetUrl}${product.logoPath}`;
    }
    return null;
  }

  protected readonly zbpIconNames = zbpIconNames;
}
